/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Component, FormEvent, MouseEvent } from 'react';
import Content from './forgot-password.content';
import { getContent, buildErrorMsgFromForm, isPB, stopProp } from '../../utils';
import { Button } from '../../_shared/button';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Logo from '../../_shared/logo';
import { Alert, message } from 'antd';
import styles from '../authentication.styles';
import SharedStyles from '../../_shared/styles';
import Link from '../../_shared/link';
import { generatePinAndSendMsgToUser } from '../../_shared/services/manage-users.service';
import { trackEvent, } from '../../_shared/services/analytics.service';
import eventTypes from '../../_shared/interfaces/api/eventTypes';
import { AppState } from '../../app.state';
import { WithForm } from '../../_shared/form';
import { get } from 'lodash';

interface IProps extends RouteComponentProps {
  appState: AppState;
  forgotPassword: (email: string) => Promise<{ CodeDeliveryDetails?: {} }>;
  form?: any;
}
export class ForgotPasswordComponent extends Component<IProps> {
  state = {
    loading: false,
    error: null,
    toDisplay: [
      {
        title: 'Email',
        var: 'email',
        validateTrigger: 'onBlur',
        rules: [
          {
            type: 'email',
            message: 'The input is not a valid E-mail. ',
            transform: (v: string) => v.trim(),
          },
          {
            required: true,
            message: 'The input is not a valid E-mail. ',
          },
          {
            max: 60,
            message: 'Email is limited to 60 characters. ',
          },
        ],
      },
    ],
  };
  goToLogin = () => {
    this.props.history.push('/login');
  };
  submit = async (e: MouseEvent | FormEvent) => {
    stopProp(e);
    if (this.state.loading) {
      return;
    }

    this.state.loading = true;
    this.setState(this.state);

    this.props.form.validateFieldsAndScroll(async (err: any, values: any) => {
      try {
        if (err) {
          const error = buildErrorMsgFromForm(err);
          message.error(error);
          return this.setState({
            loading: false,
          });
        }

        const email = values.email.toLowerCase().trim();
        trackEvent(eventTypes.forgot_password, { user: { userId: email } });

        // AER-1654: generate the pin via the backend so it is persisted
        // server-side (data-table `pins#<email>`). The reset endpoint verifies
        // the entered code against that stored pin, which is the security gate
        // for the new self-heal/auto-provision behavior. The pin itself is
        // emailed only — it is no longer passed through client router state.
        await generatePinAndSendMsgToUser(email, false);

        this.props.history.push('/forgotPasswordSubmit', {
          email,
          destination: get(this, 'props.location.state.destination')
        });
      } catch (err) {
        if (err.message && err.message === 'UserNotFoundException') {
          this.props.history.push('/forgotPasswordSubmit');
        } else {
          message.error(err.message);
          this.setState({
            loading: false,
          });
        }
      }
    });
  };
  render() {
    const { getFieldValue, Form } = this.props.form;
    const { error, loading } = this.state;
    const btnDisabled = !getFieldValue('email');
    const content = getContent(Content);
    const { appState } = this.props;
    const ispb = isPB(appState);

    return (
      <div className="ForgotPassword" css={css(styles.container)}>
        <div css={css(SharedStyles.logoWrap)}>
          <Logo />
        </div>

        <p css={css(styles.title)}>{content.title}</p>
        <p css={css([styles.subTitle, ispb ? `padding: 20px;` : null])}>
          {content.subTitle}
        </p>

        <div css={css(styles.inputContainer)}>
          <Form
            forceUpdate={this}
            layout="vertical"
            onSubmit={this.submit}
            items={this.state.toDisplay}
          >
            <div css={css(styles.buttonContainer + `margin-top: 20px;`)}>
              <Button
                loading={loading}
                title={content.button}
                onClick={this.submit}
                disabled={btnDisabled}
              />

              <Link
                css={css`
                  margin-top: 40px;
                `}
                onClick={this.goToLogin}
              >
                {content.link}
              </Link>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

export const ForgotPassword = WithForm(withRouter(ForgotPasswordComponent));
